export default {"src":"/_next/static/media/map-marker-yellow.be789a2d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};